// userReducer.js
const initialState = {
  profile: null,
  userData: null,
  loading: false,
  error: null
};

const userReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'USER_PROFILE_REQUEST':
    case 'USER_DATA_REQUEST':
      return {
        ...state,
        loading: true,
        error: null
      };
    case 'USER_PROFILE_SUCCESS':
      return {
        ...state,
        profile: action.payload,
        loading: false
      };
    case 'USER_DATA_SUCCESS':
      return {
        ...state,
        userData: action.payload,
        loading: false
      };
    case 'USER_PROFILE_FAILURE':
    case 'USER_DATA_FAILURE':
      return {
        ...state,
        loading: false,
        error: action.payload
      };
    default:
      return state;
  }
};

export default userReducer;
